import createIcon from '../../createIcon';

/**
 * @component @name Paid
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMi44OCAxNy43NlYxOUgxMS4xM1YxNy43MUMxMC4zOSAxNy41MyA4Ljc0IDE2Ljk0IDguMTEgMTQuNzVMOS43NiAxNC4wOEM5LjgyIDE0LjMgMTAuMzQgMTYuMTcgMTIuMTYgMTYuMTdDMTMuMDkgMTYuMTcgMTQuMTQgMTUuNjkgMTQuMTQgMTQuNTZDMTQuMTQgMTMuNiAxMy40NCAxMy4xIDExLjg2IDEyLjUzQzEwLjc2IDEyLjE0IDguNTEgMTEuNSA4LjUxIDkuMjJDOC41MSA5LjEyIDguNTIgNi44MiAxMS4xMyA2LjI2VjVIMTIuODhWNi4yNEMxNC43MiA2LjU2IDE1LjM5IDguMDMgMTUuNTQgOC40N0wxMy45NiA5LjE0QzEzLjg1IDguNzkgMTMuMzcgNy44IDEyLjA2IDcuOEMxMS4zNiA3LjggMTAuMjUgOC4xNyAxMC4yNSA5LjE5QzEwLjI1IDEwLjE0IDExLjExIDEwLjUgMTIuODkgMTEuMDlDMTUuMjkgMTEuOTIgMTUuOSAxMy4xNCAxNS45IDE0LjU0QzE1LjkgMTcuMTcgMTMuNCAxNy42NyAxMi44OCAxNy43NloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Paid = createIcon('Paid', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12.88 17.76V19H11.13V17.71C10.39 17.53 8.74 16.94 8.11 14.75L9.76 14.08C9.82 14.3 10.34 16.17 12.16 16.17C13.09 16.17 14.14 15.69 14.14 14.56C14.14 13.6 13.44 13.1 11.86 12.53C10.76 12.14 8.51 11.5 8.51 9.22C8.51 9.12 8.52 6.82 11.13 6.26V5H12.88V6.24C14.72 6.56 15.39 8.03 15.54 8.47L13.96 9.14C13.85 8.79 13.37 7.8 12.06 7.8C11.36 7.8 10.25 8.17 10.25 9.19C10.25 10.14 11.11 10.5 12.89 11.09C15.29 11.92 15.9 13.14 15.9 14.54C15.9 17.17 13.4 17.67 12.88 17.76Z',
      key: '1qqqvy',
    },
  ],
]);

export default Paid;
